export default [
    {
        path: '/travelers/the-lodge',
        alias: ['/travelers/lodge', '/travelers/thelodge'],
        components: {
            default: () => import(/* webpackChunkName: "lodge.passes" */ '@/views/Travelers/TheLodge/Index.vue'),
            mainMenu: () => import(/* webpackChunkName: "public.menu" */ '@/menus/Main/Public.vue'),
            footer: () => import(/* webpackChunkName: "travelers.footer" */ '@/components/Layout/TravelersFooter.vue'),
        },
        meta: {
            group: '/travelers/the-lodge',
            label: 'The Lodge at Shinnecock Hills',
            multiRoute: 'travelers.the-lodge',
        }
    },
    
];
